// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"ed178089","162":"12d113ae","936":"f0edba3b"}[chunkId] + ".chunk.js";
};